export default "__VITE_ASSET__sa6UOsLD__"